import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

class IndicatorsActionTypes extends AbstractApiActionTypes {
  SET_FILTER = "indicators/SET_FILTER";
  SET_INITIALIZED = "indicators/SET_INITIALIZED";
  SET_CONFIG_PARAM = "indicators/SET_CONFIG_PARAM";
  SET_DATA = "indicators/SET_DATA";
  SET_INDICATORS = "indicators/SET_INDICATORS";
}

export default new IndicatorsActionTypes("indicators");
